<template>
  <base-badge
    v-if="show"
    border
    color="dark"
    rounded="small"
    class="tw-uppercase"
    :text="type === 'mods' ? $t('team_member') : $t('author')"
  />
</template>

<script>
import { DISCUSSION_TYPES } from '@config/options.js'
import { useCommentAuthors } from '@composables'
import { computed, toRefs } from 'vue'
export default {
  props: {
    type: {
      validator: (val) => DISCUSSION_TYPES.includes(val),
      required: true,
    },
    userNameId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { userNameId } = toRefs(props)
    const { authors } = useCommentAuthors()

    const show = computed(() => authors.value.includes(userNameId.value))

    return { show }
  },
}
</script>
